import Tile from "../Tile";
import MUIGreyColor from "@mui/material/colors/grey";
import * as MUIColors from "@mui/material/colors";
import MainContext from "../../Context/MainContext/MainContext";
import Dashboard from "../../Utility/Crud/Dashboard";

export default class TileDashboard extends Tile {
    static contextType = MainContext; // For legacy class components

    /**
      * @returns {string} The Department name.
      */
    getTitle() {
        return this.props.dashboard ? Dashboard.getDisplayName(this.props.dashboard) : "None";
    }

    /**
     * @returns {string} The string to be used by the avatar abbreviation
     * formatter.
     */
    getAvatarString() {
        return this.props.dashboard ? Dashboard.getDisplayName(this.props.dashboard) : null;
    }

    /**
     * @returns {string} The color of the avatar.
     */
    getAvatarColor() {
        return this.props.dashboard ? Dashboard.getColor() : MUIGreyColor[400];
    }

    /**
     * Renders an icon to represent the avatar if no string is provided.
     */
    renderAvatarIcon() {
        return Dashboard.getIcon();
    }
}